import "./AboutUs.css";
const AboutUs = () => {
  return (
    <div>


      <div className="hero_img about_mobile_img">
        <img src="/assets/about/about_img.jpg" alt="" />
        {/* <img src="	https://www.crestdigitel.com/wp-content/uploads/2022/09/about_banner-scaled.jpg" alt="" /> */}
        <div className="hero_title">
        Connecting Millions… <br className="about_br" /> Where They Live, Work and Travel!
      </div>
      </div>
      <div className="container2">
        <div className="aboutpg_div1">
          <h2>
          Nation’s fastest growing IP-1 provider of end-to-end digital Connectivity Infrastructure Solutions focusing on In-Building Solutions (IBS) and Small Cells for Mobile Service Providers.
          </h2>
        </div>

        <div className="aboutpg_div2">
          <div className="aboutpg_div21">
            <div className="aboutpg_div211">
              <h2>3,400+</h2>
              <span>IBS & Small Cells installed across various locations</span>
            </div>
            <div className="aboutpg_div211">
              <h2>450+</h2>
              <span>Million Sq. Ft. covered</span>
            </div>


            <div className="aboutpg_div211">
              <h2>50%</h2>
              <span>
                Overall IBS Market Share. 82%+ in Metro Stations & 50%+ in
                Airports
              </span>
            </div>
          </div>
          <div className="aboutpg_div21">
          <div className="aboutpg_div211">
              <h2>250+</h2>
              <span>Kilometres of tunnel length covered in metros</span>
            </div>
            <div className="aboutpg_div211">
              <h2>21</h2>
              <span>
                Telecom Circles Presence with all operators as Clients
              </span>
            </div>
            <div className="aboutpg_div211">
              <h2>10+</h2>
              <span>Million Touchpoints and daily footfall on sites</span>
            </div>
            
          </div>
        </div>
        <div className="aboutpg_div3 ">
          <h2>Our Footprint</h2>
          <div className="about_map">
          <img src="/assets/about/aboutsvg.svg" alt="" />
          </div>
        </div>
        <div className="portp_div2 container about_flex">
          <div className="portp_div31">
            <img src="/assets/about/aboutimg2.jpg" alt="" />
          </div>
          <div className="portp_div21  ">
            <h2>Integrating Connectivity <br /> and Customer Centricity</h2>
            <p>
              At Crest Digitel, a Digital Connectivity Infrastructure company
              with global parentage, we are committed to providing innovative
              solutions to our business partners and stakeholders. Connecting
              people seamlessly anytime, anywhere is all about revolutionizing
              their lives. By offering customized connectivity solutions that
              are innovative and equipped with future-proof technology, we help
              our customers improve the user experience, resulting in a
              conducive work environment for the people we serve as well as a
              better and more connected world. As we strive to become the
              world’s leading provider of digital connectivity infrastructure
              across all business segments, we are progressively maturing and
              forging ahead fearlessly towards our ambition.
            </p>
          </div>
        </div>

        <div className="portp_div2 container about_img_div">
          <div className="portp_div21  ">
            <h2>Enhancing Connectivity with <br /> Superior Solutions</h2>
            <p>
              Our extensive experience and understanding of network requirements
              enable us to provide service excellence in the area of network
              infrastructure. As a result, we are better positioned to address
              both existing and future connectivity challenges for public and
              private sector clients. To assist our business partners in
              improving their customer experience and increasing revenues, we
              have developed a portfolio of innovative solutions that meet a
              variety of user needs across a wide range of scenarios, helping
              them enhance their products while minimizing their total cost of
              ownership.
            </p>
          </div>
          <div className="portp_div31">
            <img src="/assets/about/aboutimg3.jpg" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
